import {appUrl} from '@frontend/AppUrl'
import type {ExecutorDetailsTabName} from '@frontend/modules/public/services/ServicesModuleTypes'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на профиль исполнителя услуг.
// Позже, вероятно, добавится аргумент slug для SEO.
export function makeExecutorUrl(
    executorId: number,
    tab?: ExecutorDetailsTabName
): string {
    return NavigationService.makeUrl(
        appUrl().services.details,
        {id: executorId},
        tab ? {tab} : null
    )
}
